import { getCookie } from "react-use-cookie";
export const api = `${process.env.REACT_APP_API_URL}/api/v1`;

export const makeHeaders = () => {
  const token = getCookie('token');
  return {
    headers: {
      'Content-Type': 'application/json',
      'x-token': token,
    }
  };
};
